import { AppPageHeader, DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import React, { useState } from 'react';

import { useSupplierFormContext } from '@/components/Suppliers/SupplierFormProvider';
import {
  ListCreditsSupplierQuery,
  SupplierOrderColumn,
} from '@/core/domain/people/Suppliers/Suppliers.types';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import SupplierCreditListFilters from '@/components/Suppliers/SupplierCreditList/SupplierCreditListFilters';
import { Button, Empty } from 'antd';
import { useIntl } from 'react-intl';
import SupplierReturnedItemsList from '@/components/Suppliers/SupplierReturnedItemsList';
import { useItemsPurchasesReturnAll } from '@/core/domain/purchase/purchaseItem/PurchaseItem.hooks';
import { useDebounce } from '@/hooks';
import SupplierFooter from '@/components/Suppliers/SupplierFooter';

const SupplierReturnedItemsPage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl();
  const { supplierId, disabled } = useSupplierFormContext();

  const [queryParams, setQueryParams] = useState<ListCreditsSupplierQuery>({
    order: 'ASC',
    supplierId: Number(supplierId),
    orderByColumn: SupplierOrderColumn.VALUE,
  });

  const queryDebounce = useDebounce(queryParams, 500);

  const { data, isLoading, fetchNextPage, hasNextPage } =
    useItemsPurchasesReturnAll({
      supplierId: Number(supplierId),
      ...queryDebounce,
    });

  const itemsReturn = flatInfiniteData(data);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={route.parent}
      baseKey={`${supplierId}`}
      basePath={`/app/registry/suppliers/${supplierId}`}
    >
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
        searchValue={queryParams?.search}
        extraFilters={
          <SupplierCreditListFilters
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
        }
        headerActions={({
          isShowingFilters,
        }: {
          // eslint-disable-next-line react/no-unused-prop-types
          isShowingFilters: boolean;
        }) =>
          isShowingFilters && (
            <Button
              type="primary"
              onClick={() =>
                setQueryParams({
                  order: 'ASC',
                  supplierId: Number(supplierId),
                })
              }
            >
              {intl.formatMessage({ id: 'commons.clear.filters' })}
            </Button>
          )
        }
      />

      {itemsReturn.length ? (
        <>
          <SupplierReturnedItemsList
            itemsReturn={itemsReturn}
            isLoading={isLoading}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            setQueryParams={setQueryParams}
          />
        </>
      ) : (
        <Empty description="Não existe itens devolvidos para esse fornecedor!" />
      )}

      <SupplierFooter disabled={disabled} />
    </DefaultRouteTabs>
  );
};

export default SupplierReturnedItemsPage;
